import cn from 'classnames';
import { useState, useEffect, useRef, MutableRefObject } from 'react';

import { AutoshipmentCartBox } from '@zooplus/autoshipment-checkout-front';
import { useCheckoutContext } from '@zooplus/checkout-state';

import { useIsResponsiveViewport } from '@hooks/use-is-responsive-viewport';
import { CHECKOUT_STATE_PROJECT_ID, MINI_AUTOSHIPMENT_BOX } from '@utilities/constants';
import { hasMessageWithCode } from '@utilities/utilities';

import styles from './cart-autoshipment.module.scss';

type CartAutoshipmentProps = {
  keyCloackToken: MutableRefObject<string | undefined>;
  containerStyles?: string;
};

const CartAutoshipment = ({ keyCloackToken, containerStyles }: CartAutoshipmentProps) => {
  const { isFetching, checkoutState, setIsStickyAutoshipmentPresent } =
    useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);

  const [isSubscriptionBoxVisible, setIsSubscriptionBoxVisible] = useState<boolean>();

  const autoshipmentSection = useRef<HTMLElement | undefined>();
  const subscriptionBoxWrapper = useRef<HTMLElement>(null);
  const isResponsiveViewport = useIsResponsiveViewport();

  useEffect(() => {
    autoshipmentSection.current =
      (!isResponsiveViewport ||
      (isResponsiveViewport &&
        hasMessageWithCode(checkoutState?.cart?.cartMessages, 'CHECKOUT_ERROR_MINORDER'))
        ? document.getElementById(MINI_AUTOSHIPMENT_BOX.IS_NOT_STICKY)
        : document.getElementById(MINI_AUTOSHIPMENT_BOX.IS_STICKY)) || undefined;
  }, [isResponsiveViewport, checkoutState?.cart?.cartMessages.length]);

  useEffect(() => {
    const element = document.getElementById(MINI_AUTOSHIPMENT_BOX.IS_STICKY);
    setIsStickyAutoshipmentPresent?.(!!element?.hasChildNodes());
  });

  useEffect(() => {
    setIsSubscriptionBoxVisible(!subscriptionBoxWrapper?.current?.hasChildNodes());
  });

  return checkoutState?.stateAttributes?.showSubscriptionBox ? (
    <article
      ref={subscriptionBoxWrapper}
      className={cn(
        styles.marginTop,
        isSubscriptionBoxVisible && styles.hideSubscriptionBoxWrapper && 'pp-m-0',
        containerStyles,
      )}>
      {!isFetching && (
        <AutoshipmentCartBox
          keycloakToken={keyCloackToken.current}
          stickySection={autoshipmentSection.current}
        />
      )}
    </article>
  ) : null;
};

export default CartAutoshipment;
